/**
 * PasswordCriteria — live checklist driven by the shared password rules.
 */
import { checkPasswordCriteria } from '@wlb/shared/utils/validation';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { CriteriaList, type CriteriaItem } from './CriteriaList';

interface PasswordCriteriaProps {
  password: string;
  id?: string;
}

const CRITERIA = [
  ['hasMinLength', 'minLength'],
  ['hasUppercase', 'uppercase'],
  ['hasLowercase', 'lowercase'],
  ['hasNumber', 'number'],
  ['hasSpecialChar', 'specialChar'],
] as const;

export function isPasswordStrong(password: string): boolean {
  return Object.values(checkPasswordCriteria(password)).every(Boolean);
}

export function PasswordCriteria({ password, id }: PasswordCriteriaProps) {
  const { t } = useTranslation();
  const criteria = checkPasswordCriteria(password);

  const items: CriteriaItem[] = CRITERIA.map(([key, labelKey]) => ({
    key,
    label: t(`auth.passwordCriteria.${labelKey}`),
    met: criteria[key],
  }));

  return (
    <CriteriaList
      items={items}
      id={id}
      label={t('auth.passwordCriteria.title')}
      metLabel={t('auth.passwordCriteria.met')}
      notMetLabel={t('auth.passwordCriteria.notMet')}
    />
  );
}
